import { render, staticRenderFns } from "./PqtMeasurementSpecificationEditor.vue?vue&type=template&id=3ff039e7"
import script from "./PqtMeasurementSpecificationEditor.vue?vue&type=script&lang=ts"
export * from "./PqtMeasurementSpecificationEditor.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports